import React from "react";
import PropTypes from "prop-types";
import dynamic from "next/dynamic";

const GridLayout = dynamic(() => import("./layouts/grid-layout"));
const InlineLayout = dynamic(() => import("./layouts/inline-layout"));

import StyledImageCluserInfo from "./styles";

const ImageClusterInfo = (props) => {
  const items = props["cms-component-image-cluster-items"];
  const { blockName, alias, cmsHandler, CmsEditableGroupIcons, CmsAddElement } =
    props;

  const editItemProps = {
    alias,
    blockName,
    frontalListToDelete: items,
  };

  // Add Element Props
  const addProps = {
    contentId: blockName,
    itemIdDotNotation: `${blockName}.cms-component-image-cluster-items`,
    layout: "vertical",
  };

  return (
    <section id={blockName || ""}>
      <StyledImageCluserInfo>
        {CmsAddElement && (
          <CmsAddElement
            addProps={{
              index: "start",
              ...addProps,
            }}
            cmsHandler={cmsHandler}
          />
        )}
        {items &&
          items.map((item, i) => {
            if (item?.layout === "grid") {
              return (
                <GridLayout
                  {...item}
                  {...editItemProps}
                  cmsHandler={cmsHandler}
                  parentIndex={i}
                  CmsEditableGroupIcons={CmsEditableGroupIcons}
                  CmsAddElement={CmsAddElement}
                  key={`module-${i}`}
                />
              );
            }
            return (
              <InlineLayout
                {...item}
                {...editItemProps}
                cmsHandler={cmsHandler}
                parentIndex={i}
                CmsEditableGroupIcons={CmsEditableGroupIcons}
                CmsAddElement={CmsAddElement}
                key={`module-${i}`}
              />
            );
          })}
        {CmsAddElement && (
          <CmsAddElement
            addProps={{
              index: "end",
              ...addProps,
            }}
            cmsHandler={cmsHandler}
          />
        )}
      </StyledImageCluserInfo>
    </section>
  );
};

export default ImageClusterInfo;

ImageClusterInfo.propTypes = {
  /**
   * {
   *  "info": "Como se pintan el bloque de imágenes, en grid o inline.",
   *  "kind": "both",
   *  "beautifulName": "Layout",
   *  "values": "./enums.js:LAYOUT_TYPES"
   * }
   */
  layout: PropTypes.string,

  /**
   * {
   *  "info": "Dirección del bloque de texto. Normal o invertido.",
   *  "kind": "both",
   *  "beautifulName": "Dirección",
   *  "values": "./enums.js:DIRECTION_TYPES"
   * }
   */
  direction: PropTypes.string,

  /**
   * {
   *  "info": "Color del fondo",
   *  "kind": "both",
   *  "beautifulName": "Color"
   * }
   */
  backgroundColor: PropTypes.string,

  /**
   * {
   *  "info": "Ocultar velo en la fla",
   *  "kind": "both",
   *  "beautifulName": "Ocultar velo"
   * }
   */
  hideShadow: PropTypes.bool,
};
